import { Component, OnDestroy } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { faAngleLeft, faAngleRight, faChevronDown, faChevronUp, faTimes } from '@fortawesome/free-solid-svg-icons';
import { Subscription } from 'rxjs';
import { Globals } from 'src/classes/global';
import { SeoService } from 'src/services/seo.service';
import { TranslatorService } from 'src/services/translator.service';
import { BaseRoutedComponent } from '../../base-route.component';
import { SearchService } from 'src/services/search.service';
import { FiltroQuick, FiltroQuickFlat, QuickValue, SearchResult } from 'src/classes/search-result';
import { KeyValue, KeyValueSlide } from 'src/classes/key-value';
import { UtilyService } from 'src/services/utility.service';
import { Category } from 'src/classes/category';
import { DeviceDetectorService } from 'ngx-device-detector';
import { LoadingService } from 'src/services/loading.service';
import { NgcCookieConsentService } from 'ngx-cookieconsent';
import { ChangeContext, LabelType, Options } from 'ngx-slider-v2';
import { StorageService } from 'src/services/storage.service';

@Component({
  selector: 'app-search-categories',
  templateUrl: './search-categories.component.html',
  styleUrls: ['./search-categories.component.scss']
})
export class SearchCategoriesComponent extends BaseRoutedComponent implements OnDestroy {
  id!:string;
  descrizione!:string;
  categories: Array<Category>= [];
  tipologiaRicerca!: string;

  idComparto!:string;
  idBrand!:string;  

  searchResult: SearchResult = { minPrice: 0, maxPrice: 9999, totaleProdotti: 0, titoloRicerca: "", results: [] };
  minValue: number = 0;
  maxValue: number = 9999;
  page: number = 0;
  rowPage: number = 20;
  ordinamento: number = 0;
  breadCrumb: Array<any>= [];
  controlSearch!: number;

  options: Options = {
    floor: 0,
    ceil: 9999,
    translate: (value: number, label: LabelType): string => {
      switch (label) {
        case LabelType.Low:
          return '€ ' + value;
        case LabelType.High:
          return '€ ' + value;
        default:
          return '€ ' + value;
      }
    }
  };

  filtriSelezionati: Array<FiltroQuickFlat> = [];
  filtriSlideSelezionati: Array<KeyValueSlide> = [];
  filtriQuick: Array<FiltroQuick> = [];
  togglePrice: boolean = false;
  limitValueToSlide:number = 50;
  disableScrolling:boolean = false;  
  showFiltriQuick!:boolean;

  faTimes = faTimes;
  faAngleLeft = faAngleLeft;
  faAngleRight = faAngleRight;
  faChevronUp = faChevronUp;
  faChevronDown = faChevronDown;

  slideConfig!:any;
  navigationSubscription: Subscription;
  constructor(
    public global: Globals,
    protected router: Router,
    protected utilyService: UtilyService,
    protected searchService: SearchService,    
    protected loadingService: LoadingService,
    protected deviceService: DeviceDetectorService,
    protected override route: ActivatedRoute,        
    protected override seoService: SeoService,
    protected override storageService: StorageService,
    protected override translatorService: TranslatorService,
    protected override cookieService: NgcCookieConsentService) {
    super(route, seoService, storageService, translatorService, cookieService);

      this.navigationSubscription = this.router.events.subscribe((e: any) => {
        if (e instanceof NavigationEnd) {
          this.route.params.subscribe(params => {
            this.searchResult = { minPrice: 0, maxPrice: 9999, totaleProdotti: 0, titoloRicerca: "", results: [] };
            this.tipologiaRicerca = params['id'][0];
            this.id = params['id'].slice(1);
            this.idComparto = this.tipologiaRicerca == 'K' ? this.id : "";
            this.idBrand = this.tipologiaRicerca == 'B' ? this.id : "";
            this.descrizione = this.utilyService.decodeURLParameter(params['descrizione']);
            this.breadCrumb = [];
            this.disableScrolling = false;
            this.filtriSlideSelezionati = [];
            this.filtriSelezionati = [];
            this.ordinamento = 0;
            this.minValue = 0;
            this.maxValue = 9999;
            this.options = {
              floor: this.minValue,
              ceil: this.maxValue
            };

            this.showFiltriQuick = false;
            this.initialiseInvites();
          });
        }
      });
    }

    get isMobile(){
      return this.deviceService.isMobile() ;
    }
  
    get isDesktop(){
      return this.deviceService.isDesktop() ;
    }  

    initialiseInvites() {
      this.setSeo();
      this.slideConfig = {
        "slidesToShow": 1,
        "slidesToScroll": 1,
        "autoplay": true,
        "dots": false,
        "infinite": true,
        "arrows": false
      };

      if( this.tipologiaRicerca == 'B') {
        this.searchService.getCategorieBrand(this.id).subscribe((response: any) => {
          this.categories = response;
          if(this.categories.length == 1){
            var redirectRoute = "/" + this.global.culture + "/search-products/" + this.setUrl(this.categories[0]);
            this.router.navigate([redirectRoute]);
          }
        });
      }
      else if(this.tipologiaRicerca == 'K') {
        this.searchService.getCategorieComparto(this.id).subscribe((response: any) => {
          this.categories = response;
          if(this.categories.length == 1){
            var redirectRoute = "/" + this.global.culture + "/search-products/" + this.setUrl(this.categories[0]);
            this.router.navigate([redirectRoute]);
          }
        });
      }

      this.cerca(false);
    }

    setSeo(){
      let title = "WAG Bike | " + this.descrizione;
      this.seoService.setTitle(title);    
    }

    cerca(filtraPrezzi: boolean) {
      let quickSel: Array<KeyValue> = this.filtriSelezionati.map(el => { return { key: el.id, value: el.idValue } as KeyValue });
      this.page = 0;
      this.loadingService.onShow();
      this.searchService.getSearchProduct("", this.idBrand, this.idComparto, this.rowPage, this.page, this.showFiltriQuick, quickSel, this.filtriSlideSelezionati,
                                      filtraPrezzi ? this.minValue : null, filtraPrezzi ? this.maxValue : null, this.ordinamento)
        .subscribe((res: any) => {
          this.disableScrolling = false;
          this.searchResult = res;
          this.loadingService.onDelayHide(500);
        });
  
      this.searchService.getSearchQuicks("", this.idBrand, this.idComparto, this.rowPage, this.page, this.showFiltriQuick, quickSel, this.filtriSlideSelezionati,
                                      filtraPrezzi ? this.minValue : null, filtraPrezzi ? this.maxValue : null, this.ordinamento)
        .subscribe((res: any) => {
          this.disableScrolling = false;
  
          var ricalcoloFiltri: Array<FiltroQuick> = [];
          res.quicks.forEach((item:FiltroQuick)=> {
            var filter = this.filtriSelezionati.filter(obj => obj.id == item.id);
            var filterSlide = this.filtriSlideSelezionati.filter(obj => obj.key == item.id);
            if(filter.length > 0){
              var lastFilter = this.filtriQuick.filter(obj => obj.id == filter[0].id)[0];
              ricalcoloFiltri.push(lastFilter);
            }
  
            if(filterSlide.length > 0){
              var lastFilter = this.filtriQuick.filter(obj => obj.id == filterSlide[0].key)[0];
              ricalcoloFiltri.push(lastFilter);
            }
            
            if(filter.length == 0 && filterSlide.length == 0){
              if(item.idTipo == 2 && item.valori.length > this.limitValueToSlide) {
                var split = item.valori[0].value.split(' ');
                if(split.length > 1){
                  item.unitaDiMisura = split[1];
                }
                item.minValue = Math.min.apply(Math, item.valori.map(function(o) { return +o.value.split(' ')[0]; }));
                item.minValueSelected = item.minValue;
    
                item.maxValue = Math.max.apply(Math, item.valori.map(function(o) { return +o.value.split(' ')[0]; }));
                item.maxValueSelected = item.maxValue;
              }            
              ricalcoloFiltri.push(item);
            }
          });
  
          this.filtriQuick = ricalcoloFiltri;       
          this.setInactive();
  
          res.quicks.forEach((f1: FiltroQuick) => {
            f1.valori.forEach((v1: QuickValue) => {
              this.filtriQuick.find((x) => {
                if (x.id == f1.id) {
                  x.valori.find(k => {
                    if (k.idValue == v1.idValue) {
                      k.inactive = false;
                    }
                  });
                }
              });
            });
          });
  
          this.dynamicOpenFilterTab();
  
          if (!filtraPrezzi) {
            this.minValue = res.minPrice;
            this.maxValue = res.maxPrice;
            this.options = {
              floor: res.minPrice,
              ceil: res.maxPrice
            };
          }
        });
    }

    dynamicOpenFilterTab(){
      this.filtriQuick.forEach((item) => {
        item.isOpen = false;
        if(item.id == 'CATEGORIE' || item.id == 'BRAND' || item.id == 'PROMO'){
          item.isOpen = true;
        }
        else 
        {
          if(this.filtriSelezionati.length > 0 || this.filtriSlideSelezionati.length > 0){
            item.isOpen = true;
          }
        }
      });
    }

    setInactive(idEccezione:string| null = null) {
      this.filtriQuick.forEach(element => {
        if(element.id != null && element.id != idEccezione){
          element.valori.forEach(v => {
            v.inactive = true;
          });
        }
      });
    }

    addToFiltri(id: string, idQuick: string, voceFiltro: QuickValue) {
      const elem = { id: id, quick: idQuick, idValue: voceFiltro.idValue, value: voceFiltro.value } as FiltroQuickFlat;
  
      if (voceFiltro.checked) {
        this.filtriSelezionati.push(elem);
      }
      else {
        this.filtriSelezionati = this.filtriSelezionati.filter(obj => !(obj.id == elem.id && obj.idValue == elem.idValue));
      }

      let cateogrySelected = this.filtriSelezionati.filter(obj => obj.id == "CATEGORIE").length;

      if(cateogrySelected == 1){
        this.showFiltriQuick = true;
      }else{
        this.showFiltriQuick = false;
      }

      this.cerca(true);
    }

    cleanFiltriAttivi(id: string = '', idValue: string = ''): void {
      if (id != '' && idValue != '') {
        this.filtriSelezionati = this.filtriSelezionati.filter(obj => !(obj.id == id && obj.idValue == idValue));
  
        this.filtriQuick.find((x) => {
          if (x.id == id) {
            x.valori.find(k => {
              if (k.idValue == idValue) {
                k.checked = false;
              }
            });
          }
        });        
        this.cerca(true);
      }
      else {
        this.filtriSelezionati = [];
        this.filtriSlideSelezionati = [];
        this.cerca(false);
      }
    }

    onScroll() {
      if(!this.disableScrolling){
        this.appendItem(true);
      }
    }
  
    appendItem(filtraPrezzi: boolean) {
      let quickSel: Array<KeyValue> = this.filtriSelezionati.map(el => { return { key: el.id, value: el.idValue } as KeyValue });
      this.page += 1;
      this.disableScrolling= true;
      this.searchService.getSearchProduct("", this.idBrand, this.idComparto, this.rowPage, this.page, this.showFiltriQuick, quickSel, this.filtriSlideSelezionati, filtraPrezzi ? this.minValue : null, filtraPrezzi ? this.maxValue : null, this.ordinamento)
        .subscribe((res: any) => {
          this.disableScrolling = res.results.length != 0 ? false : true; //se torna risultati sblocco l'infinity scroll 
          
          res.results.forEach((item:any) => {
            this.searchResult.results.push(item);
          });
        });
    }

    onUserChangeEnd(changeContext: ChangeContext): void {
      this.cerca(true);
    }

    onUserChangeEndFilter(changeContext: ChangeContext, filter: FiltroQuick): void {    
      var filterExsist = false;
      this.filtriSlideSelezionati.forEach(f => {
        if(f.key == filter.id){
          filterExsist = true;
          if(changeContext.pointerType == 0){
            f.minValue = changeContext.value;
          }
          if(changeContext.pointerType == 1){
            f.maxValue = changeContext.value;
          }
        }
      });
  
      if(!filterExsist){
        var filterSlide = { key: filter.id, minValue: filter.minValue, maxValue: filter.maxValue };
        if(changeContext.pointerType == 0){
          filterSlide.minValue = changeContext.value;
        }
        if(changeContext.pointerType == 1){
          filterSlide.maxValue = changeContext.value;
        }
  
        this.filtriSlideSelezionati.push(filterSlide);
      }
      this.cerca(true);
    }

    cleanUp(testo:string):string {
      return this.utilyService.encodeURLParameter(testo);
    }

    ngOnDestroy() {
      if (this.navigationSubscription) {
        this.navigationSubscription.unsubscribe();
      }
    }

    setUrl(category:Category) {
      return this.tipologiaRicerca == 'B' ?  "X" + category.idCategoria + '-' + this.id + "/" + this.cleanUp(category.categoria + '-' + this.descrizione)
      : this.tipologiaRicerca == 'K' ? 'C' + category.idComparto + '-' + category.idCategoria+"/" + this.cleanUp(category.comparto + "-" + category.categoria)
      : "";
    }
}
